<template>
  <div>
    <select-base
      :ref="'tipoTributacaoSelect'"
      v-model="valueInner"
      :disabled="disabled"
      :require="require_"
      :multiple="multiple"
      :label="'Tipos de Tributação'"
      :label-select="'nome'"
      :carregar="carregarTiposTributacao"
      :filtro-adicional="filtroAdicional"
      @input="enviarParaPai"
    />
  </div>
</template>

<script>
import api from '@/app-modulo/comercial/tipo-tributacao/shared/services/api'
import '@core/scss/vue/libs/vue-select.scss'

export default {
  name: 'TipoTributacaoSelect',
  components: {
    SelectBase: () => import('@/shared/components/select-base/SelectBase.vue'),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    require: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Object, Array],
      default: () => { },
    },
    filtroAdicional: {
      type: Function,
      default: () => null,
    },
  },
  data() {
    return {
      value_: {},
      filtros: [
        {
          coluna: 'Nome',
          valor: '',
        },
      ],
    }
  },
  computed: {
    valueInner: {
      set(value) {
        // eslint-disable-next-line no-underscore-dangle
        this.value_ = value
      },
      get() {
        // eslint-disable-next-line no-underscore-dangle
        return this.value_
      },
    },
    require_: {
      get() {
        return this.require
      },
    },
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
      }
    },
  },
  created() {
    this.valueInner = this.value
  },
  methods: {
    carregarTiposTributacao(filtros) {
      return api.getTributacoesResumidas(filtros)
    },
    enviarParaPai() {
      this.$emit('input', this.valueInner)
    },
  },
}
</script>
